import { separator } from "../WSUtils/keySeparator";

export const TRANSLATION_PREVIEW_PREFIX = "__TRANSLATION";

export const getTranslationPreviewKey = (
  frontendId: string,
  locale: string
) => {
  if (!frontendId.startsWith("cvp-")) frontendId = `cvp-${frontendId}`;
  return `${TRANSLATION_PREVIEW_PREFIX}${separator}${locale}${separator}${frontendId}`;
};

export const decodeTranslationPreviewKey = (translationPreviewKey: string) => {
  const [__, locale, frontendId] = translationPreviewKey.split(separator);

  return { locale, frontendId };
};
